import { createDeferred, type Deferred } from './deferred'

let current: Deferred<void> = createDeferred<void>()

export const pageVisibleOnce = {
  get promise() {
    return current.promise
  },
  done: (v: void) => current.done(v),
  /** @internal — used by __resetForTests in native.ts */
  __resetForTests(): void {
    current = createDeferred<void>()
  },
}
